import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Phone, Search, RefreshCw, CheckCircle2 } from "lucide-react";
interface TimelineStep {
  icon: any;
  title: string;
  description: string;
  time: string;
}
interface TimelineSectionProps {
  companyName: string;
  companyColor: string;
}
const TimelineSection = ({
  companyName,
  companyColor
}: TimelineSectionProps) => {
  const steps: TimelineStep[] = [{
    icon: AlertCircle,
    title: "Vorfall erkennen",
    description: "Sie bemerken verdächtige Aktivitäten oder einen Cyberangriff auf Ihre Systeme.",
    time: "Sofort"
  }, {
    icon: Phone,
    title: "24/7 Hotline anrufen",
    description: "Kontaktieren Sie die Notfall-Hotline. Experten stehen rund um die Uhr bereit.",
    time: "Innerhalb weniger Minuten"
  }, {
    icon: Search,
    title: "Forensik beginnt",
    description: "IT-Forensiker analysieren den Vorfall und leiten Sofortmaßnahmen ein.",
    time: "Innerhalb von 4 Stunden"
  }, {
    icon: RefreshCw,
    title: "Wiederherstellung",
    description: "Systeme werden bereinigt, Daten wiederhergestellt und Sicherheitslücken geschlossen.",
    time: "1-5 Tage"
  }, {
    icon: CheckCircle2,
    title: "Schadensregulierung",
    description: "Alle Kosten werden geprüft und erstattet. Ihre Praxis ist wieder voll einsatzbereit.",
    time: "7-14 Tage"
  }];
  return <section className="py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3">
            Ablauf im Schadensfall
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground max-w-2xl mx-auto">
            So unterstützt Sie {companyName} Schritt für Schritt bei einem Cyberangriff
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Timeline Line - Hidden on mobile, visible on md+ */}
            <div className="hidden md:block absolute left-8 top-0 bottom-0 w-0.5 bg-accent/40" />

            <div className="space-y-4 sm:space-y-6">
              {steps.map((step, index) => {
              const Icon = step.icon;
              return <div key={index} className="relative">
                    <Card className="hover:shadow-lg transition-all duration-300">
                      <CardContent className="p-4 sm:p-5 lg:p-6">
                        <div className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left gap-3 sm:gap-4">
                          {/* Icon Circle */}
                          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center relative z-10 rounded-full bg-black/[0.01]">
                            <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-accent" />
                          </div>

                          {/* Content */}
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 sm:gap-2 mb-2">
                              <h3 className="text-base sm:text-lg font-bold">
                                {step.title}
                              </h3>
                              {step.time && <span className="text-xs sm:text-sm font-semibold px-2 py-1 rounded-full w-fit mx-auto md:mx-0 bg-accent/15 text-accent break-words hyphens-auto max-w-full">
                                  {step.time}
                                </span>}
                            </div>
                            <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                              {step.description}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TimelineSection;